import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { create } from "zustand";

type Message = { success: boolean; message: string };

export type MessageStoreProps = {
  message: Message | null;
  setMessage: (message: Message) => void;
  removeMessage: () => void;
};

const useMenuStore = create<MessageStoreProps>((set) => ({
  message: null,
  setMessage: (message) => set({ message }),
  removeMessage: () => set({ message: null }),
}));

const useMessageProps = (props: any) => {
  const current = useMenuStore((state) => state.message);
  const setMessage = useMenuStore((state) => state.setMessage);
  const removeMessage = useMenuStore((state) => state.removeMessage);

  useEffect(() => {
    if (props.redirect_props) setMessage(props.redirect_props);
  }, [props.redirect_props]);

  useEffect(() => {
    if (current) {
      const { success, message } = current;

      if (success) {
        toast.success(message || "Success", { onClose: removeMessage });
      } else if (message) {
        toast.error(message, { onClose: removeMessage });
      }
    }
  }, [current]);
};

export default useMessageProps;
